import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useHistory } from 'react-router';
import { useCustomHotkeys } from '../../common/hooks/useCustomHotkeys';

interface IProps {
  previousLink: string;
  nextLink: string;
  total: number;
  current: number;
  isLoading: boolean;
  disabled: boolean;
  callback?: () => void;
}

export const ImageNavigation = observer((props: IProps): ReactElement => {
  const history = useHistory();
  const { t } = useTranslator();

  const goTo = (to: string): void => {
    if (props.disabled) {
      return;
    }

    props.callback?.();
    history.push(to);
  };

  useCustomHotkeys(
    'left',
    () => {
      goTo(props.previousLink);
    },
    { enabled: props.current > 1 && !props.isLoading, keydown: false, keyup: true },
    [goTo]
  );
  useCustomHotkeys(
    'right',
    () => {
      goTo(props.nextLink);
    },
    { enabled: props.current < props.total && !props.isLoading, keydown: false, keyup: true },
    [goTo]
  );

  return (
    <div className='image-navigation'>
      <Button
        variant='outlined'
        onClick={() => {
          goTo(props.previousLink);
        }}
        startDecorator={<FontAwesomeIcon icon='angle-left' />}
        disabled={props.current <= 1 || props.isLoading || props.disabled}
      >
        {t('previous')}
      </Button>
      <span className='images-count'>
        {props.current} {t('of')} {props.total}
      </span>
      <Button
        onClick={() => {
          goTo(props.nextLink);
        }}
        startDecorator={<FontAwesomeIcon icon='angle-right' />}
        disabled={props.current >= props.total || props.isLoading || props.disabled}
      >
        {t('next')}
      </Button>
    </div>
  );
});
